requirejs(['hp', 'restaurants', 'restaurant', 'contact-us'],
  function(hp, restaurants, restaurant, contactUs) {
    var maps = [
      [/^(\/)?$/, hp],
      [/^\/\?(.*)$/, hp],
      [/^restaurant\/(.+)/, restaurant],
      [/^restaurants\/(.+)/, restaurants],
      [/^contact-us\/(.+)/, contactUs],
    ],
        REGEX = 0,
        FUNCTION = 1,
        found = false;
    if (typeof is404 === 'undefined') {
      for (var i=0; i<maps.length; i++) {
        var pathname = window.location.pathname.slice(1),
            map = maps[i];
        if (map[REGEX].test(pathname)) {
          map[FUNCTION]();
          found = true;
          i = maps.length;
        }
      }
    }
    if (!found) {
      require(['jquery', 'common']);
    }
  }
);
define("main", function(){});

